module.exports = __webpack_public_path__ + "static/media/header-instagram.8424eba9.svg";